export class FetchAssociatedUpdatePackagesReqData {
    installationNames: string[] = null;
}
